import { render } from "./EditorInfoPanel.vue?vue&type=template&id=3c45a2b4&scoped=true"
import script from "./EditorInfoPanel.vue?vue&type=script&lang=js"
export * from "./EditorInfoPanel.vue?vue&type=script&lang=js"

import "./EditorInfoPanel.vue?vue&type=style&index=0&id=3c45a2b4&scoped=true&lang=css"

import exportComponent from "/home/runner/work/webapp/webapp/main/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c45a2b4"]])

export default __exports__